import {SubMenuBeds} from '../features/bed/components/SubMenu/SubMenuBeds'
import {SubMenuModule} from '../features/modules/components/SubMenu/SubMenuModules'
import {SubMenuRooms} from '../features/room/components/SubMenu/SubMenuRooms'

export const ListSubMenusHoteleria = {
  modules: <SubMenuModule />,
  rooms: <SubMenuRooms />,
  beds: <SubMenuBeds />,
  '': <></>,
} as any
